import { skipToken, useQuery, type QueryClient } from '@tanstack/react-query';
import { StatusCode } from '@hungryroot/rest';
import {
  getCustomerOrder,
  type OrderDetail as Order,
} from '@hungryroot/rest/api/v2/customers/[id]/orders/[order_id]/get';

const getOrderQueryKey = (orderId?: number) => [
  'Orders',
  'bundle order',
  orderId,
];

export async function invalidateOrders(queryClient: QueryClient) {
  await queryClient.invalidateQueries({
    queryKey: ['Orders'],
  });
}

export function useGetOrder(
  orderId?: number,
  options?: {
    enabled?: boolean;
    refetchInterval?: Parameters<typeof useQuery<Order>>[0]['refetchInterval'];
  }
) {
  const timeLimit = 5 * 60 * 1000;
  return useQuery({
    queryKey: getOrderQueryKey(orderId),
    queryFn: orderId
      ? async () => {
          const resp = await getCustomerOrder({ orderId });

          if (resp.status !== StatusCode.SuccessOK) {
            throw new Error(JSON.stringify(resp.data, null, 2));
          }

          return resp.data;
        }
      : skipToken,
    ...options,
    gcTime: timeLimit,
    staleTime: timeLimit,
  });
}
